/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import useAPIHandler from '../hook/use-api-handler';
import { logger } from '../utils/logger';

const useOrgDetailsDataHook = () => {
	const [organizationInfo, setOrganizationInfo] = useState({})
	const { fetchData } = useAPIHandler();
	const fetchOrgDetailsData = async () => {
		try {
			const url = "report/salary?month=1&year=2025&pageLimit=25&page=1&search="
			const response = await fetchData({
				url: url,
				method: 'GET',
			});
			setOrganizationInfo(response?.data?.org_details)
			logger.log(response, "salaryReportListData7777")
		} catch (error) {
			logger.log(error)
		}
	}
	useEffect(() => {
		fetchOrgDetailsData()
	}, [])
	return {
		organizationInfo
	}
}

export default useOrgDetailsDataHook